export const images = {
  "00caguamon": require("@/assets/img/products/00_CAGUAMON.png"),
  "01caguama": require("@/assets/img/products/01_CAGUAMA.png"),
  "02caguamita": require("@/assets/img/products/02_CAGUAMITA.png"),
  "03laton": require("@/assets/img/products/03_LATON.png"),
  "04lata": require("@/assets/img/products/04_LATA.png"),
  "05media": require("@/assets/img/products/05_MEDIA.png"),
  //"06media355": require("@/assets/img/products/06_MEDIA_355.png"),
  //"07six": require("@/assets/img/products/07_SIX.png"),
  "0dots": require("@/assets/img/products/0_dots.svg"),
  "01dots": require("@/assets/img/products/0_dots.svg"),
  "02dots": require("@/assets/img/products/0_dots.svg"),
  "0pintura": require("@/assets/img/products/0_pintura.svg"),
  "0prices": require("@/assets/img/products/0_prices.svg"),
};
